module.exports = __webpack_public_path__ + "img/LTC-ability-08.7d264679.png";